/* Coty Optique — carrousels produit « focus » (détourage, boucle continue, glisser, défilement auto) */
(() => {
  'use strict';
  if (window.__cotyFC) return; window.__cotyFC = true;

  /* Détourage des photos sur fond blanc → PNG transparent (mis en cache) */
  const cache = new Map();
  const cutout = (src, maxW = 900) => {
    // le détourage passe par coty-color (Web Worker, hors du fil principal) quand il est chargé
    if (window.cotyColor && window.cotyColor.cutoutLike) return window.cotyColor.cutoutLike(src, src);
    if (cache.has(src)) return cache.get(src);
    const p = new Promise((res) => {
      const im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = () => {
        try {
          const s = Math.min(1, maxW / im.naturalWidth);
          const w = Math.round(im.naturalWidth * s), h = Math.round(im.naturalHeight * s);
          const c = document.createElement('canvas'); c.width = w; c.height = h;
          const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, w, h);
          const data = x.getImageData(0, 0, w, h), px = data.data;
          const ci = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2]].map(([a, b]) => (b * w + a) * 4);
          if (ci.some(i => px[i + 3] < 250)) return res(src); // déjà transparent
          let br = 0, bg = 0, bb = 0; ci.forEach(i => { br += px[i]; bg += px[i + 1]; bb += px[i + 2]; }); br /= 4; bg /= 4; bb /= 4;
          if (br < 225 || bg < 225 || bb < 225) return res(src); // fond non blanc : on garde la photo
          let x0 = w, y0 = h, x1 = 0, y1 = 0;
          for (let k = 0, n = w * h; k < n; k++) {
            const i = k * 4;
            const d = Math.max(br - px[i], bg - px[i + 1], bb - px[i + 2], 0) / 255;
            const a = Math.min(1, Math.max(0, (d - .012) * 5.2));
            if (a <= 0) { px[i + 3] = 0; continue; }
            if (a < 1) {
              px[i] = Math.max(0, Math.min(255, (px[i] - (1 - a) * br) / a));
              px[i + 1] = Math.max(0, Math.min(255, (px[i + 1] - (1 - a) * bg) / a));
              px[i + 2] = Math.max(0, Math.min(255, (px[i + 2] - (1 - a) * bb) / a));
            }
            px[i + 3] = Math.round(a * 255);
            if (a > .2) { const xx = k % w, yy = (k / w) | 0; if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
          }
          x.putImageData(data, 0, 0);
          if (x1 <= x0 || y1 <= y0) return res(c.toDataURL('image/png'));
          const o = document.createElement('canvas'); o.width = x1 - x0 + 5; o.height = y1 - y0 + 5;
          o.getContext('2d').drawImage(c, Math.max(0, x0 - 2), Math.max(0, y0 - 2), o.width, o.height, 0, 0, o.width, o.height);
          res(o.toDataURL('image/png'));
        } catch (e) { res(src); }
      };
      im.onerror = () => res(src);
      im.src = src;
    });
    cache.set(src, p); return p;
  };
  window.cotyCutout = window.cotyCutout || cutout;

  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp01 = v => Math.max(0, Math.min(1, v));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.fcReady) return; root.dataset.fcReady = '1';
    const track = root.querySelector('[data-track]');
    const items = [...root.querySelectorAll('[data-item]')];
    // Peu de produits : on duplique la liste pour garder 5 paires visibles (centre + voisins + extrémités floues)
    if (items.length > 1 && items.length < 7) {
      const orig = items.slice(), anchor = track.querySelector('[data-prev]');
      while (items.length < 7) orig.forEach(o => {
        const c = o.cloneNode(true); c.setAttribute('aria-hidden', 'true');
        const h = c.querySelector('[data-cut]'); if (h) { delete h.dataset.done; h.classList.remove('is-ready'); h.querySelectorAll('img').forEach(i => i.remove()); }
        track.insertBefore(c, anchor); items.push(c);
      });
    }
    const infos = [...root.querySelectorAll('[data-info]')];
    const n = items.length; if (!n) return;

    // Images détourées, chargées quand le carrousel approche de l'écran
    const load = () => items.forEach(it => {
      const h = it.querySelector('[data-cut]'); const src = h && h.dataset.src; if (!src || h.dataset.done) return; h.dataset.done = '1';
      (window.cotyColor ? window.cotyColor.cutoutLike(src, src) : cutout(src)).then(u => { const img = new Image(); img.alt = h.dataset.alt || ''; img.draggable = false; img.decoding = 'async'; img.onload = () => h.classList.add('is-ready'); img.src = u; h.appendChild(img); });
    });
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver(e => { if (e.some(x => x.isIntersecting)) { load(); io.disconnect(); } }, { rootMargin: '600px' }); io.observe(root); } else load();

    const wrap = o => { o = ((o % n) + n) % n; if (o >= n / 2) o -= n; return o; };
    const mobile = () => track.clientWidth < 750;
    const spacing = () => mobile() ? track.clientWidth * .6 : Math.min(track.clientWidth * .26, 380);
    const styleFor = o => {
      const a = Math.abs(o); let st;
      if (mobile()) {
        st = a <= 1 ? { s: lerp(1, .62, a), blur: lerp(0, 1.5, a), op: lerp(1, .5, a) } : { s: .62, blur: 3, op: lerp(.5, 0, clamp01((a - 1) / .4)) };
        st.op *= clamp01((n / 2 - a) / .5);
        return st;
      }
      if (a <= 1) st = { s: lerp(1, .74, a), blur: 0, op: lerp(1, .9, a) };
      else if (a <= 2) st = { s: lerp(.74, .6, a - 1), blur: lerp(0, 6, a - 1), op: lerp(.9, .5, a - 1) };
      else { const t = clamp01((a - 2) / .5); st = { s: lerp(.6, .5, t), blur: lerp(6, 10, t), op: lerp(.5, 0, t) }; }
      st.op *= clamp01((n / 2 - a) / .5);
      return st;
    };
    let pos = Math.min(Math.floor(n / 2), n - 1), target = pos, shown = -1;
    function render() {
      const sp = spacing();
      items.forEach((it, i) => {
        const o = wrap(i - pos), st = styleFor(o);
        it.style.transform = `translate(-50%, -50%) translateX(${(o * sp).toFixed(2)}px) scale(${st.s.toFixed(4)})`;
        it.style.filter = st.blur > .2 ? `blur(${st.blur.toFixed(2)}px)` : 'none';
        it.style.opacity = st.op.toFixed(3);
        it.style.visibility = st.op < .01 ? 'hidden' : '';
        it.style.zIndex = 100 - Math.round(Math.abs(o) * 10);
        it.classList.toggle('is-current', Math.abs(o) < .5);
        it.tabIndex = Math.abs(o) <= 1.5 ? 0 : -1;
      });
      const idx = ((Math.round(target) % n) + n) % n;
      if (idx !== shown) {
        shown = idx; const cur = items[idx];
        infos.forEach(info => {
          info.classList.remove('is-in');
          const v = info.querySelector('[data-info-vendor]'); if (v) v.textContent = cur.dataset.vendor || '';
          const t = info.querySelector('[data-info-title]'); if (t) t.textContent = cur.dataset.title || '';
          const p = info.querySelector('[data-info-price]'); if (p) p.textContent = cur.dataset.price || '';
          info.querySelectorAll('[data-info-link]').forEach(a => (a.href = cur.dataset.url));
          const sw = info.querySelector('[data-info-swatches]'); if (sw) paintSwatches(sw, cur);
          requestAnimationFrame(() => info.classList.add('is-in'));   // relance de l'animation sans recalcul de mise en page forcé
        });
      }
    }
    // Coloris de la paire au centre : pastilles sous les lunettes, clic = la paire change de couleur
    const MAXSW = 10;
    function setColor(item, d, k) {
      item.dataset.sel = k;
      if (d.u) { item.href = d.u; item.dataset.url = d.u; root.querySelectorAll('.fc__foot [data-info-link], .fc__info [data-info-link]').forEach(a => (a.href = d.u)); }
      if (!d.s) return;
      const h = item.querySelector('[data-cut]'); if (!h) return;
      const cc = window.cotyColor, ref = h.dataset.src || d.s;
      (cc ? cc.cutoutLike(d.s, ref) : cutout(d.s)).then(u => {
        let img = h.querySelector('img:not(.cc-morph)');
        if (!img) { img = new Image(); img.draggable = false; img.onload = () => h.classList.add('is-ready'); img.src = u; h.appendChild(img); return; }
        if (cc) cc.morphTo(img, u); else img.src = u;
      });
    }
    function paintSwatches(ul, item) {
      let list = []; try { list = JSON.parse(item.dataset.swatches || '[]'); } catch (e) {}
      ul.innerHTML = '';
      if (list.length < 2) { ul.hidden = true; return; }
      ul.hidden = false;
      const sel = +(item.dataset.sel || 0);
      list.slice(0, MAXSW).forEach((d, k) => {
        const li = document.createElement('li'), b = document.createElement('button');
        b.type = 'button'; b.className = 'swatch' + (k === sel ? ' is-active' : ''); b.setAttribute('style', d.c || ''); b.title = d.n; b.setAttribute('aria-label', d.n);
        b.addEventListener('click', e => { e.preventDefault(); lastInteract = performance.now(); ul.querySelectorAll('.swatch').forEach(x => x.classList.toggle('is-active', x === b)); setColor(item, d, k); });
        b.addEventListener('mouseenter', () => { if (d.s && window.cotyColor) window.cotyColor.cutoutLike(d.s, item.querySelector('[data-cut]')?.dataset.src || d.s); });
        if (d.s && window.cotyColor) window.cotyColor.paint(b, d.s);
        li.appendChild(b); ul.appendChild(li);
      });
      if (list.length > MAXSW) { const li = document.createElement('li'); li.className = 'swatches__more'; li.innerHTML = '<a href="' + (item.dataset.url || '#') + '">+' + (list.length - MAXSW) + '</a>'; ul.appendChild(li); }
    }
    let raf = 0, last = 0, dragging = false, lastInteract = 0;
    function step(ts) {
      const dt = last ? Math.min(64, ts - last) : 16.7; last = ts;
      if (!dragging) { const d = target - pos; pos += d * (1 - Math.pow(1 - .16, dt / 16.7)); if (Math.abs(d) < .0005) pos = target; }
      render();
      if (dragging || pos !== target) raf = requestAnimationFrame(step); else { raf = 0; last = 0; }
    }
    const kick = () => { if (!raf) { last = 0; raf = requestAnimationFrame(step); } };
    const go = d => { target = Math.round(target) + d; lastInteract = performance.now(); kick(); };
    root.querySelector('[data-prev]')?.addEventListener('click', () => go(-1));
    root.querySelector('[data-next]')?.addEventListener('click', () => go(1));
    items.forEach((it, i) => it.addEventListener('click', e => { const o = Math.round(wrap(i - pos)); if (o !== 0) { e.preventDefault(); go(o); } }));
    track.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } });

    let sx = 0, sy = 0, start = 0, moved = false, pid = null, samples = [];
    track.addEventListener('pointerdown', e => {
      if (e.button !== undefined && e.button !== 0) return;
      if (e.target.closest('[data-prev],[data-next]')) return;
      pid = e.pointerId; sx = e.clientX; sy = e.clientY; start = pos; moved = false; samples = [[performance.now(), e.clientX]];
    });
    track.addEventListener('pointermove', e => {
      if (pid !== e.pointerId) return;
      const dx = e.clientX - sx, dy = e.clientY - sy;
      if (!dragging) {
        if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;
        dragging = true; moved = true; lastInteract = performance.now();
        try { track.setPointerCapture(pid); } catch (err) {}
        track.classList.add('is-dragging'); kick();
      }
      pos = start - dx / spacing();
      samples.push([performance.now(), e.clientX]); if (samples.length > 6) samples.shift();
    });
    const release = e => {
      if (pid !== e.pointerId) return; pid = null;
      if (!dragging) return; dragging = false; lastInteract = performance.now();
      track.classList.remove('is-dragging');
      const a = samples[0], b = samples[samples.length - 1];
      const v = a && b && b[0] > a[0] ? (b[1] - a[1]) / (b[0] - a[0]) : 0;
      target = Math.round(Math.max(pos - 2, Math.min(pos + 2, pos - (v * 220) / spacing())));
      kick();
    };
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('lostpointercapture', release);
    track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', e => e.preventDefault());

    let visible = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(e => { visible = e[0].isIntersecting; }).observe(root); else visible = true;
    // Défilement automatique : une paire toutes les `ap` secondes. Le compte à rebours repart après chaque geste.
    // Carrousel qui reçoit la paire du hero : il ne démarre qu'une fois la paire posée.
    const ap = parseFloat(root.dataset.autoplay || '0');
    if (ap > 0 && !reduced && n > 1) {
      let nextAt = performance.now() + ap * 1000;
      setInterval(() => {
        const now = performance.now();
        const held = !visible || document.hidden || dragging || root.querySelector('.fc__sw:hover') ||
          (root.hasAttribute('data-hv-target') && !root.hasAttribute('data-hv-landed'));
        if (held) { nextAt = now + ap * 1000; return; }
        nextAt = Math.max(nextAt, lastInteract + Math.max(ap, 5) * 1000);
        if (now < nextAt) return;
        target = Math.round(target) + 1; kick(); nextAt = now + ap * 1000;
      }, 200);
    }
    let rt; addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(render, 120); });
    render();
  }

  const scan = () => document.querySelectorAll('[data-fc]:not([data-fc-ready])').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
